import React from 'react';
import Link from '../../../elements/Link';
import styles from './StartNetworkingStep.module.scss';

function StartNetworkingStep(props) {
    const {className, visible = true, done = false, complete = false, onClick, href, children, enabled = true, disabledHint} = props;

    // TODO: use enabled + disabledHint

    if (!visible) {
        return null;
    }

    return (
        <Link
            className={[styles.StartNetworkingStep, className, done ? styles.done : '', complete ? styles.complete : '', !enabled ? styles.disabled : ''].join(
                ' '
            )}
            href={href}
            onClick={onClick}
            disabled={!enabled}>
            <div className={styles.icon} />
            <div className={styles.content}>{children}</div>
        </Link>
    );
}

export default StartNetworkingStep;
